export const device = {
    sm: "@media screen and (min-width: 36rem)",
    md: "@media screen and (min-width: 48rem)",
    lg: "@media screen and (min-width: 64rem)",
    xl: "@media screen and (min-width: 80rem)",
    xxl: "@media screen and (min-width: 120rem)",
};
